import lowerCase from 'lodash.lowercase'
import upperFirst from 'lodash.upperfirst'

export const humanizeText = (text: string): string =>
  upperFirst(lowerCase(text))
